import { render, staticRenderFns } from "./LendingPage_Community.vue?vue&type=template&id=5183e657&scoped=true&"
import script from "./LendingPage_Community.vue?vue&type=script&lang=js&"
export * from "./LendingPage_Community.vue?vue&type=script&lang=js&"
import style0 from "./LendingPage_Community.vue?vue&type=style&index=0&id=5183e657&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5183e657",
  null
  
)

export default component.exports